import * as tocbot from 'tocbot';
import QRCode from "qrcode";
import * as Highcharts from 'highcharts';
import '../components/highcharts-options'

import * as main from './main';
import * as utils from '../utils';

import { getMapData, getForecastData, getStatisticsTimeSeriesData, getRegionalStatisticsData, getHeatmapData, getFairmodeData, getStripesData } from '../components/io'
import { plotStatisticsTimeSeries } from '../components/charts/time-series-statistics';
import { plotForecast } from '../components/charts/time-series-forecast';
import { initTargets, plotTargetCircle, plotTargetBars } from '../components/charts/targets'
import { plotMap } from '../components/charts/map'
import { plotStripes } from '../components/charts/stripes'
import { plotContingencyColumns } from '../components/charts/contingency-columns';

import camsFrontpageHeader from '../../public/reports/cams-template/CAMS-frontpage-header.png'
import camsFrontpageFooter from '../../public/reports/cams-template/CAMS-frontpage-footer.png'

declare var MathJax: any;

// import interfaces and extend window variable
import { Aeroval } from '../types/global';
import { FairmodeData, ForecastData, HMData, HMTSData } from '../types/data';
import '../styles/reports.css'
import { plotRegionalStatisticsSingleModel } from '../components/charts/regional-statistics-single-model';

// Extend the Globals interface
interface ExtendedGlobals extends Aeroval {
	report: any;
	reportStats: {
		nTables: number;
		nFigures: number;
		nSection: number;
		nSectionFigures: number;
		nSubsection: number;
		nSubsubsection: number;
	};
	startTime: Date;
	endTime: Date;
	formulaWidth: any;
}
declare var aeroval: ExtendedGlobals;

document.addEventListener('DOMContentLoaded', () => {
	if (window.location.pathname.includes('pages/reports')) {
		init();
	}
});

function init() {
	console.log('initialize report page');
	//check if any queries
	aeroval.seriesVisibility = {};
	if (window.location.href.includes('cams2-82')) {
		aeroval.menuButtons = ['model', 'region', 'time-no_seasons-no_freqs'];
	} else if (window.location.href.includes('cams2-83')) {
		aeroval.menuButtons = ['model', 'region', 'time-no_all-no_freqs-no_periods'];
	}

	main.getQueryStrings();
	main.getExperiments(true, false, false);
	main.updateURLs('project', aeroval.project);
}

export async function callbackMenu() {
	makeDivs();
}

export function update(which: string, what: string) {
	console.info('update ', which, 'with ', what);
	// we set the following array to zero length as the export all gets all the charts from this array
	Highcharts.charts.length = 0;

	if (which == 'mean_and_statistic' || which == 'statistic' || which == 'forecast_statistic') {
		aeroval.statistic = aeroval.statistics[what];
		aeroval.statistic.dir = what;
		if (what == 'data_mean') {
			aeroval.statistic.name = 'Mean';
			aeroval.statistic.longname = 'Mean (Obs and Model)';
		}
		main.topMenu(true, true);
	}
	if (which == 'region') {
		aeroval[which] = what;
		main.topMenu(true, true);
		utils.updateQueryString(which, what);
		main.updateURLs(which, what);
		utils.updateQueryString('station', '');
		main.updateURLs('station', '');
	}
	if (which == 'experiment') {
		aeroval.experiment = aeroval.experiments[what];
		aeroval.experiment.name = what;
		main.getExperiments(true);
		utils.updateQueryString(which, what);
		main.updateURLs(which, what);
	}
	if (which == 'obsType') {
		aeroval[which] = what;
		main.topMenu(true, true);
	}
	if (which == 'frequency') {
		aeroval[which] = what as Aeroval['frequency'];
		utils.updateQueryString('stats', what);
		main.updateURLs('stats', what);
		main.topMenu(true, true);
	}
	if (which.includes('time')) {
		aeroval.time = what;
		main.topMenu(true, true);
		main.updateURLs('time', what);
		utils.updateQueryString('time', what);
		main.getExtremeDates();
	}
	if (which == 'season') {
		aeroval[which] = what as Aeroval['season'];
		main.topMenu(true, true);
		utils.updateQueryString(which, what);
		main.updateURLs('season', what);
	}
	if (which == 'model') {
		// remove some data
		delete aeroval.data.hm;

		aeroval.model = {
			dir: what,
			name: what,
			var: aeroval.modVars[what],
		};
		utils.updateQueryString(which, what);
		main.topMenu(true, true);
	}
}

async function makeDivs() {
	//create divs
	var h = '';
	if (aeroval.project == 'cams2-83' || aeroval.project == 'cams2-82') {
		h += "<div id='main-content'>";
		if (!aeroval.isMobile) {
			var h = `<div class="alert alert-dismissible alert-light fade show my-2 w-100" role="alert" style="display: inline-flex; justify-content: space-between; align-items: center;">
				<div>
					Download PDF document </br> <i>We recommend using Google Chrome with the "background graphics" option activated</i>.
				</div>
				<div>
					<button id="print-pdf" type="button-sm" class="btn btn-primary px-2" title="print" disabled><i class="bi bi-file-pdf-fill"></i></button>
				</div>
			</div>
			</div>`;
		}

		// content container
		h += '<div id="report-container"></div>';
		h += '</div>';
	} else {
		utils.todo();
	}
	const main = document.getElementById('main');
	if (main) {
		main.innerHTML = h;
	}

	const reportContent = await loadReportContent();
	const linkedReportContent = await makeLinks(reportContent);
	makeReport(linkedReportContent);
	await addContributors(linkedReportContent)
	addCAMSDisclaimer()
	addTOC(linkedReportContent)
	addCAMSCoverPage(linkedReportContent)
	addQRCode()
	//addCAMSHeader()

	// set up button actions
	const printPDFButton = document.getElementById('print-pdf');
	if (printPDFButton) {
		printPDFButton.addEventListener('click', function () {
			print()
		});
	}

	window.addEventListener("beforeprint", () => {
		beforePrint(linkedReportContent)
	});

	window.addEventListener("afterprint", () => {
		afterPrint()
	});

}

function addQRCode() {
	// Remove the existing QR code element if it exists
	const existingQRCode = document.getElementById('qr-code');
	if (existingQRCode) {
		existingQRCode.remove();
	}

	// Create the header div element
	const qrCodeDiv = document.createElement('div');
	qrCodeDiv.id = 'qr-code'
	var h = `<canvas id="qr-code-canvas"></canvas>`
	qrCodeDiv.innerHTML = h

	const reportContainerElement = document.getElementById('report-container');
	reportContainerElement!.appendChild(qrCodeDiv);

	const qrCodeCanvas = document.getElementById('qr-code-canvas')
	const qrText = window.location.href; // Example: Current page URL
	QRCode.toCanvas(qrCodeCanvas, qrText, {
		width: 100, // Adjust size as needed
		margin: 1
	});
}

function addCAMSDisclaimer() {
	// Remove the existing disclaimer element if it exists
	const existingDisclaimer = document.getElementById('disclaimer');
	if (existingDisclaimer) {
		existingDisclaimer.remove();
	}

	// Create the header div element
	const disclaimerDiv = document.createElement('div');
	disclaimerDiv.id = 'disclaimer'
	disclaimerDiv.className = 'break-before break-after p-4'

	var h = `<div id="disclaimer-content">This document has been produced in the context of the Copernicus Atmosphere Monitoring Service (CAMS).
	The activities leading to these results have been contracted by the European CEntre for Medium-Range Weather Forecasts,
	operator of CAMS on behalf on the European Union (Contribution Agreement signed on 22/07/2021).
	All information in this document is provided "as is" and no guarantee or warranty is given that the information is fit for any particular purpose.
	The users thereof use the information at their sole risk and liability. For the avoidance of all doubt, the European Commission and 
	and the European Centre for Medium-Range Weather Forecasts have no liability in respect of this document, which is merely representing the authors' view.</div>`
	disclaimerDiv.innerHTML = h

	const reportContainerElement = document.getElementById('report-container');
	const firstReportElement = reportContainerElement?.firstChild;
	if (reportContainerElement && firstReportElement) {
		reportContainerElement.insertBefore(disclaimerDiv, firstReportElement);
	}
}

async function addContributors(reportContent: any) {
	if (!(Object.keys(reportContent).includes('contributors'))) return

	// Remove the existing disclaimer element if it exists
	const existingContributors = document.getElementById('contributors');
	if (existingContributors) {
		existingContributors.remove();
	}

	// Create the header div element
	const contributorsDiv = document.createElement('div');
	contributorsDiv.id = 'contributors'
	var h = `<h2 class="break-before">Contributors</h2>
		<ul>`

	const contributorsReport = reportContent['contributors']
	var contributorsContent = contributorsReport

	if (typeof contributorsReport == 'string' && contributorsReport.endsWith('.json')) {
		const fileName = contributorsReport
		const url = `${window.API_ROOT}/file/reports/${aeroval.project}/${aeroval.experiment.name}/${fileName}${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}`
		if (!url || !fileName) return;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				'Accept': 'application/json'
			}
		});

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}
		const data = await response.json();
		contributorsContent = data[aeroval.model.dir]
	}

	for (let institution in contributorsContent) {
		h += `<li> ${institution} </li>
			<ul>`
		const team = contributorsContent[institution]
		for (const person of team) {
			h += `<li>${person}</li>`
		}
		h += '</ul>'
	}
	h += '</ul>'
	contributorsDiv.innerHTML = h

	const reportContainerElement = document.getElementById('report-container');
	const firstReportElement = reportContainerElement?.firstChild;
	if (reportContainerElement && firstReportElement) {
		reportContainerElement.insertBefore(contributorsDiv, firstReportElement);
	}
}

function addTOC(reportContent: any) {
	if (!(Object.keys(reportContent).includes('table-of-contents'))) return

	// Remove the existing TOC element if it exists
	const existingTOC = document.getElementById('toc');
	if (existingTOC) {
		existingTOC.remove();
	}

	const tocReport = reportContent['table-of-contents']

	// Create the header div element
	const tocDiv = document.createElement('div');
	tocDiv.id = 'toc'
	tocDiv.innerHTML = `
		<h2 class="break-before js-toc-ignore">${tocReport.title}</h2>
		<div id="js-toc"></div>
	`

	// Append the toc div to the document body
	const targetElement = document.getElementById(`section-${tocReport.after.replaceAll(' ', '-')}`)
	if (targetElement && targetElement.parentNode) {
		targetElement.parentNode.insertBefore(tocDiv, targetElement.nextSibling);
	}

	(tocbot as any).init({
		tocSelector: '#js-toc',
		ignoreSelector: '.js-toc-ignore',
		contentSelector: '#report-container',
		headingSelector: 'h2, h3, h4, h5',
		orderedList: false
	});

}

function beforePrint(reportContent: any) {
	const chartsConfig = {
		ts: {
			width: 740,
		},
		fcst: {
			width: 740
		},
		map: {
			width: 800
		},
		'target-circle': {
			width: 400
		},
		'target-bar': {
			width: 620
		},
		default: {
			width: 500
		},
		qrtr: {
			width: 740
		},
		reg: {
			width: 740,
			xAxis: {
				labels: {
					allowOverlap: true,
					style: {
						fontSize: '0.4rem',
					}
				},
			}
		}
	} as any
	var chartConfig = chartsConfig.default as any
	for (let chart of Highcharts.charts) {
		for (let key in chartsConfig) {
			var which = (chart as any).renderTo.id as string
			if (which.startsWith('trgt')) {
				which = (chart as any).renderTo.classList[0]
			}
			if (which.startsWith(key)) {
				chartConfig = chartsConfig[key]
				continue
			}
		}
		// modulate chart width by div width
		const chartContainer = document.getElementById((chart as any).renderTo.id)
		const chartContainerWidth = Number(chartContainer?.style.width.split('%')[0])
		const chartWidth = chartContainerWidth ? chartConfig.width * chartContainerWidth / 100 : chartConfig.width
		const chartXAxis = chartConfig.xAxis ? chartConfig.xAxis : undefined

		chart?.update({
			chart: {
				animation: false,
				plotShadow: false,
				width: chartWidth,
			},
			xAxis: chartXAxis,
		}, true)
	}

	// change document title
	document.title = reportContent.ref
}

function afterPrint() {
	const chartsConfig = {
		'target-circle': {
			width: 400
		},
		default: {
			width: document.getElementById('report-container')!.offsetWidth - 80,
			xAxis: {
				labels: {
					style: {
						fontSize: '0.8em',
					}
				},
			}
		}
	} as any
	var chartConfig = chartsConfig.default as any

	for (let chart of Highcharts.charts) {
		for (let key in chartsConfig) {
			var which = (chart as any).renderTo.id as string
			if (which.startsWith('trgt')) {
				which = (chart as any).renderTo.classList[0]
			}
			if (which.startsWith(key)) {
				chartConfig = chartsConfig[key]
				continue
			}
		}
		chart?.update({
			chart: {
				animation: false,
				plotShadow: false,
				width: chartConfig.width
			},
			xAxis: chartConfig.xAxis ? chartConfig.xAxis : undefined,
		}, true)
	}
}

/*function addCAMSHeader() {
	// Create the header div element
	const headerDiv = document.createElement('div');
	headerDiv.className = 'report-header';

	// Create the img element
	headerDiv.innerHTML = 'Copernicus Atmosphere Monitoring Service 2'

	// Append the header div to the document body
	document.body.appendChild(headerDiv);
}*/

function addCAMSCoverPage(reportContent: any) {

	// Check if an existing cover page element exists and remove it
	const existingCoverPage = document.getElementById('cover-page');
	if (existingCoverPage) {
		existingCoverPage.remove();
	}

	// Create the header div element
	const coverDiv = document.createElement('div');
	coverDiv.id = 'cover-page'
	coverDiv.className = 'break-after'

	// Create the img element
	coverDiv.innerHTML = `
		<div class="cover-header">
			<img src="${camsFrontpageHeader}" alt="Header Image">
		</div>
		<div class="cover-content">
			<h1>${reportContent.title}</h1>
			<h2 style="color: #5acddf">${reportContent.subtitle}</h2>
			<div id="cover-info">
				<div>Issued by: ${reportContent.issued_by}</div>
				<div>Date: ${reportContent.date}</div>
				<div>Ref: ${reportContent.ref}</div>
			</div>
		</div>
		<div class="cover-footer">
			<img src="${camsFrontpageFooter}" alt="Footer Image">
		</div>`

	// Append the header div to the document body
	document.body.append(coverDiv);
}

async function loadReportContent(): Promise<ExtendedGlobals['reports']> {
	var url: string | undefined = undefined;
	var title: string | undefined = undefined
	if (aeroval.project == 'cams2-83') {
		let keyTime = `${aeroval.season}${aeroval.time}`
		title = `EQC-report_${aeroval.model.dir}_${aeroval.season}${aeroval.time}`
		url = `${window.API_ROOT}/file/reports/${aeroval.project}/${aeroval.experiment.name}/${keyTime}/${title}${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}.json`
		console.log(url)
	} else if (aeroval.project == 'cams2-82') {
		title = `QL-report_${aeroval.model.dir}_${aeroval.time}`
		url = `${window.API_ROOT}/reports/${aeroval.project}/${aeroval.experiment.name}/${title}${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}`
	}
	if (!url || !title) return;

	// load report
	try {
		const response = await fetch(url, {
			method: 'GET',
			headers: {
				'Accept': 'application/json'
			}
		});

		if (!response.ok) {
			throw new Error('Network response was not ok');
		}

		const data = await response.json();

		// Insert model name
		let strData = JSON.stringify(data);
		strData = strData.replaceAll('*model*', aeroval.model.name);
		strData = strData.replaceAll('*time*', `${aeroval.season}${aeroval.time}`);

		// Replace special characters
		/*const specialCharacters: { [key: string]: string } = {
			'↗': "<svg fill='#0d6efd' height='16' width='16' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d='M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z'/></svg>",
			'↘': "<svg fill='#dc3545' height='16' width='16' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d='M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256S397.4 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z'/></svg>",
		}
		for (const specialCharacter in specialCharacters) {
			strData = strData.replaceAll(specialCharacter, specialCharacters[specialCharacter]);
		}*/

		return JSON.parse(strData) as ExtendedGlobals['report'];
	} catch (error) {
		console.error('There was a problem with the fetch operation:', error);
		const h = '<div class="alert alert-warning" role="alert" style="margin: 50px auto">No report is available for the current selection</div>';
		// Send content to div
		const innerDiv = document.getElementById('report-container');
		if (innerDiv) {
			innerDiv.innerHTML = h;
		}
	}
}

async function makeLinks(content: any): Promise<any> {
	aeroval.report = content;
	// loop through each section
	for (const i in content.sections) {
		// loop through content
		for (const j in content.sections[i].content) {
			// linkify all keys
			for (const key in content.sections[i].content[j]) {
				if (key != 'options') {
					content.sections[i].content[j][key] = utils.linkify(String(content.sections[i].content[j][key]));
				}
			}
		}
	}
	return content
}

async function makeReport(content: any) {
	// global count of figures for later reference
	aeroval.reportStats = {
		nTables: 0,
		nFigures: 0,
		nSection: 0,
		nSectionFigures: 0,
		nSubsection: 0,
		nSubsubsection: 0,
	};

	aeroval.fairmodeStats = {}

	var h = '';
	for (const section of content.sections) {
		if (section.filter) {
			// region filter
			if ((section.filter.region) && !(section.filter.region.includes(aeroval.region))) {
				continue
			}
		}
		const sectionTitle = section.title.split('# ')[1] ? section.title.split('# ')[1] : section.title
		const sectionId = sectionTitle.replaceAll(' ', '-')
		h += `<div id="section-${sectionId}">`
		// add title
		if (section.title.startsWith('# ')) {
			aeroval.reportStats.nSection++;
			aeroval.reportStats.nSectionFigures = 0;
			aeroval.reportStats.nSubsection = 0;
			aeroval.reportStats.nSubsubsection = 0;
			var numerotation = String(aeroval.reportStats.nSection);
			// default: break-before
			h += `<h2 class="break-before" id="${sectionId}">${numerotation} ${sectionTitle}</h2>`
		} else if (section.title.startsWith('## ')) {
			aeroval.reportStats.nSubsection++;
			aeroval.reportStats.nSubsubsection = 0;
			numerotation = `${aeroval.reportStats.nSection}.${aeroval.reportStats.nSubsection}`;
			h += ('pageBreak' in section && section.pageBreak == 'before')
				? `<h3 class="break-before" id="${sectionId}">${numerotation} ${sectionTitle}</h3>`
				: `<h3 id="${sectionId}">${numerotation} ${sectionTitle}</h3>`
		} else if (section.title.startsWith('### ')) {
			aeroval.reportStats.nSubsubsection++;
			numerotation = `${aeroval.reportStats.nSection}.${aeroval.reportStats.nSubsection}.${aeroval.reportStats.nSubsubsection}`;
			h += ('pageBreak' in section && section.pageBreak == 'before')
				? `<h4 class="break-before" id="${sectionId}">${numerotation} ${sectionTitle}</h4>`
				: `<h4 id="${sectionId}">${numerotation} ${sectionTitle}</h4>`
		} else {
			// if no number
			h += `<h2 class="break-before" id="${sectionId}">${section.title}</h2>`
		}
		// add content
		if (section.content) {
			for (let content of section.content) {
				h += addContent(content);
			}
		}
		h += '</div>';
	}

	// add figures ids
	h = addFiguresRefById(h)

	// send content to div
	const innerDiv = document.getElementById('report-container');
	if (innerDiv) {
		const contentDiv = document.createElement('div');
		contentDiv.className = 'report-container';
		contentDiv.innerHTML = h;
		innerDiv.appendChild(contentDiv);
	}

	// load charts
	for (let section of content.sections) {
		if (section.content) {
			for (let content of section.content) {
				if (content.id && content.type === 'chart') {
					await loadChart(content.id, content.options);
				} else if (content.type === 'chart-panel') {
					const contentIds = content.ids.split(',')
					for (let contentId of contentIds) {
						const contentOptions = structuredClone(content.options)
						const indexOfContentId = contentIds.indexOf(contentId)
						if (indexOfContentId == 0) {
							var position = 'first'
						} else if (indexOfContentId == contentIds.length - 1) {
							position = 'last'
						} else {
							position = 'middle'
						}
						await loadChart(contentId, contentOptions, position);
					}
				} else if (content.id && content.type === 'table') {
					await loadTable(content.id)
				}
			}
		}
	}

	// fill up tables
	const fairmodeTable = document.getElementById('fairmode-table')
	if (fairmodeTable) {
		console.log('fill up fairmode table')
	}

	const printButton = document.getElementById('print-pdf')
	if (printButton instanceof HTMLButtonElement) {
		printButton.disabled = false
	}

}

function addFiguresRefById(content: string): string {
	// check in the content for dif[#]
	var newContent = content
	var figRefInContent = true

	while (figRefInContent) {
		//work with substract of text
		const from = newContent.indexOf('fig[#')
		if (from == -1) break;

		var partText = newContent.substring(from)
		const to = from + partText.indexOf(']') + 1
		partText = newContent.substring(from, to)

		const figId = partText.split('[#')[1].split(']')[0]
		const figNum = newContent.split(`caption-${figId}`)[1]?.split('<b>')[1]?.split('</b>')[0]
		newContent = replaceBetween(newContent, from, to, `<a href="#${figId}">${figNum}</a>`)

		// check if needs to continue
		figRefInContent = newContent.includes('fig[#')
	}
	return newContent
}

function replaceBetween(origin: string, startIndex: number, endIndex: number, insertion: string): string {
	return origin.substring(0, startIndex) + insertion + origin.substring(endIndex);
}

function addContent(content: any): string | undefined {
	var html: string | undefined = undefined;
	if (content.type == 'chart') {
		html = `<div class="figure-report">
			<div id="${content.id}" class="chart"></div>`;
		if (content.caption?.length > 0) {
			aeroval.reportStats.nSectionFigures++;
			const contentTitle = content.title.endsWith('#') ? content.title.split('#')[0] : content.title
			const numerotation = content.title.endsWith('#') ? `${aeroval.reportStats.nSection}.${aeroval.reportStats.nSectionFigures}` : ''
			html += `<div class="caption" id="caption-${content.id}"><b>${contentTitle} ${numerotation}</b>: ${content.caption}</div>`;
		}
		html += `</div>`
	} else if (content.type == 'chart-panel') {
		html = `<div class="figure-report">
			<div class="chart-panel">`;
		const chartIds = content.ids.split(',')
		const chartWidth = content.ncol ? 100 / content.ncol : 100
		for (var chartId of chartIds) {
			html += `<div id="${chartId}" class="chart" style="width: ${chartWidth}%"></div>`;
		}
		html += `</div>`
		if (content.caption?.length > 0) {
			aeroval.reportStats.nSectionFigures++;
			const contentTitle = content.title.endsWith('#') ? content.title.split('#')[0] : content.title
			const numerotation = content.title.endsWith('#') ? `${aeroval.reportStats.nSection}.${aeroval.reportStats.nSectionFigures}` : ''
			html += `<div class="caption" id="caption-${chartId}"><b>${contentTitle} ${numerotation}</b>: ${content.caption}</div>`;
		}
		html += `</div>`
	} else if (content.type == 'paragraph') {
		html = `<p>${content.text}</p>`;
	} else if (content.type == 'table') {
		html = `<div class="table-responsive">${content.text.replaceAll('<table', "<table class='table table-hover'")}`;
		if (content.caption?.length > 0) {
			aeroval.reportStats.nTables++;
			const contentTitle = content.title.endsWith('#') ? content.title.split('#')[0] : content.title
			const numerotation = content.title.endsWith('#') ? `${aeroval.reportStats.nTables}` : ''
			html += `<div class="caption"><b>${contentTitle} ${numerotation}: </b>${content.caption}</div>`;
		}
		html += `</div>`
	} else if (content.type == 'figure') {
		aeroval.reportStats.nFigures++;
		const contentUrl = content.url.replaceAll('*time*', `${aeroval.season}${aeroval.time}`)
		const src = `${window.API_ROOT}/reports_images/${aeroval.project}/${aeroval.experiment.name}/${contentUrl}`;
		const id = content.id ? content.id : '';
		const imgWidth = content.width ? content.width : '100%'
		html = `<figure class="text-center" style="margin: 0px 0px 20px 0px;">`;
		html += `<img crossorigin="anonymous" ref="img-ref-${aeroval.reportStats.nFigures}" id="${id}" class="img-static img-fluid mx-auto" src="${src}" style="width: ${imgWidth}; aspect-ratio: auto;">`;
		if (content.caption?.length > 0) {
			aeroval.reportStats.nSectionFigures++;
			html += `<figcaption `
			if (id) {
				html += `id="caption-${id}"`
			}
			if (content.title.endsWith('#')) {
				var numerotation = `${aeroval.reportStats.nSection}.${aeroval.reportStats.nSectionFigures}`;
				html += `class="caption"><b>${content.title.replace('#', numerotation)}</b>: ${content.caption}</figcaption>`;
			} else {
				html += `class="caption"><b>${content.title}</b>: ${content.caption}</figcaption>`;
			}
		}
		html += '</figure>';
	} else if (content.type == 'figure-panel') {
		aeroval.reportStats.nFigures++;
		const panelWidth = content.width ? content.width : '100%'
		html = `<figure id="${content.id}" class="text-center figure-panel mx-auto d-block" style="margin: 0px 0px 20px 0px; width: ${panelWidth}">`
		const urls = content.urls.split(',')
		const imgWidth = content.ncol ? 100 / content.ncol : 100
		for (var url of urls) {
			const contentUrl = url.replaceAll('*time*', `${aeroval.season}${aeroval.time}`)
			const src = `${window.API_ROOT}/reports_images/${aeroval.project}/${aeroval.experiment.name}/${contentUrl}`;
			const id = content.id ? content.id : '';
			html += `<img crossorigin="anonymous" ref="img-ref-${aeroval.reportStats.nFigures}" class="img-static img-fluid" src="${src}" style="width: ${imgWidth}%">`;
			if (url == urls[urls.length - 1] && content.caption?.length > 0) {
				aeroval.reportStats.nSectionFigures++;
				html += `<figcaption `
				if (id) {
					html += `id="caption-${id}"`
				}
				if (content.title.endsWith('#')) {
					var numerotation = `${aeroval.reportStats.nSection}.${aeroval.reportStats.nSectionFigures}`;
					html += `class="caption"><b>${content.title.replace('#', numerotation)}</b>: ${content.caption}</figcaption>`;
				} else {
					html += `class="caption"><b>${content.title}</b>: ${content.caption}</figcaption>`;
				}
			}
		}

		html += '</figure>';
	} else if (content.type == 'equation') {
		var equation = MathJax.tex2svg(content.text.replace(/\\\\/g, '\\').replaceAll('$$', ''));
		equation.firstChild.setAttribute('width', '100%');
		html = `<div class="formula-container">
			${equation.innerHTML}
		</div>`
		html = html.replace('<svg', '<svg class="formula"');
		// add formula class to svg
	} else if (content.type == 'reference') {
		html = `<p>
			${content.authors}, 
			<b>${content.title}</b>, 
			<i>${content.journal}</i>, 
			${content.url}, 
			${content.date}.
		</p>`
	} else {
		console.warn('unknown content type:', content.type);
	}

	return html;
}

async function loadChart(id: string, chartOptions: any = {}, position: string = '') {
	const mainId = id.split('?')[0]
	const queries = id.split('?')[1]

	const type = mainId.split('_')[0];
	const observation = mainId.split('_')[1];
	const parameterDir = mainId.split('_')[2];
	const layer = mainId.split('_')[3];
	const statisticDir = mainId.split('_')[4];

	const groupBy = 'None'
	//var models = (aeroval.project == 'cams2-83' && modelDir != 'ENSEMBLE') ? [modelDir, 'ENSEMBLE'] : [modelDir]
	var modelDir = aeroval.model.dir
	var models = [modelDir]
	if (queries && queries.includes('models=')) {
		const modelsQuery = queries.split('models=')[1].split('&')[0]
		if (modelsQuery) {
			models = modelsQuery.split('|')
			modelDir = models[0]
		}
	}

	const firstModel = Object.keys(aeroval.menu[parameterDir].obs[observation][layer])[0]
	const modelVar = aeroval.menu[parameterDir].obs[observation][layer][firstModel].model_var
	const region = aeroval.region as string

	if (chartOptions.title?.enabled == 'firstOnly') {
		chartOptions.title.enabled = position == 'first' ? true : false
	}
	if (chartOptions.title?.enabled == 'lastOnly') {
		chartOptions.title.enabled = position == 'last' ? true : false
	}
	if (chartOptions.legend?.enabled == 'firstOnly') {
		chartOptions.legend.enabled = position == 'first' ? true : false
	}
	if (chartOptions.legend?.enabled == 'lastOnly') {
		chartOptions.legend.enabled = position == 'last' ? true : false
	}


	if (type.startsWith('ts')) {
		chartOptions.height = 280
		chartOptions.lineWidth = 2
		chartOptions.markerRadius = 4
		chartOptions.show_number_points = true
		const seasonBoundaries = (!aeroval.time.includes('-')) ? utils.getSeasonBoundaries(Number(aeroval.time), aeroval.season) : undefined
		chartOptions.xAxisMin = seasonBoundaries?.startDate.valueOf()
		chartOptions.xAxisMax = seasonBoundaries?.endDate.valueOf()
		if (type.startsWith('ts-an')) {
			const analExperimentName = aeroval.experiment.name.replace('forecast', 'analysis')
			const fcstExperimentName = `forecast-anaobs`

			chartOptions.show_number_points = false
			chartOptions.models = []

			var statsTsAnalData = await getStatisticsTimeSeriesData(aeroval.project, analExperimentName, region, observation, parameterDir, layer)
			var statsTsFcstData = await getStatisticsTimeSeriesData(aeroval.project, fcstExperimentName, region, observation, parameterDir, layer)
			if (!statsTsAnalData || !statsTsFcstData) return
			// intialize data structure
			var statsTsData = {
				[parameterDir]: {
					[observation]: {
						[layer]: {
						}
					}
				}
			} as any as undefined | HMTSData
			for (const model of models) {
				statsTsData![parameterDir][observation][layer][`${model}-an`] = statsTsAnalData[parameterDir][observation][layer][model]
				statsTsData![parameterDir][observation][layer][`${model}-fc`] = statsTsFcstData[parameterDir][observation][layer][model]
				chartOptions.models.push(`${model}-an`, `${model}-fc`)
			}
		} else {
			experimentName = aeroval.experiment.name
			chartOptions.models = models
			var statsTsData = await getStatisticsTimeSeriesData(aeroval.project, experimentName, region, observation, parameterDir, layer)
		}
		if (statsTsData) plotStatisticsTimeSeries(statsTsData, parameterDir, observation, layer, statisticDir, groupBy, id, chartOptions);
	} else if (type.startsWith('fcst')) {
		chartOptions.models = models
		chartOptions.height = 280
		if (type.startsWith('fcst-an')) {
			const analExperimentName = aeroval.experiment.name.replace('forecast', 'analysis')
			const fcstExperimentName = `forecast-anaobs`

			chartOptions.models = []
			var forecastAnalData = await getForecastData(aeroval.project, analExperimentName, region, observation, parameterDir, layer)
			var forecastFcstData = await getForecastData(aeroval.project, fcstExperimentName, region, observation, parameterDir, layer)
			if (!forecastAnalData || !forecastFcstData) return

			// intialize data structure
			var forecastData = {
				[parameterDir]: {
					[observation]: {
						[layer]: {
						}
					}
				}
			} as any as undefined | ForecastData
			for (const model of models) {
				forecastData![parameterDir][observation][layer][`${model}-an`] = forecastAnalData[parameterDir][observation][layer][model]
				forecastData![parameterDir][observation][layer][`${model}-fc`] = forecastFcstData[parameterDir][observation][layer][model]
				chartOptions.models.push(`${model}-an`, `${model}-fc`)
			}

		}
		else if (type.startsWith('fcst-mos')) {
			experimentName = `mos-last-seasons`
			var forecastData = await getForecastData(aeroval.project, experimentName, region, observation, parameterDir, layer)
		} else {
			experimentName = aeroval.experiment.name
			var forecastData = await getForecastData(aeroval.project, experimentName, region, observation, parameterDir, layer)
		}
		if (forecastData) plotForecast(forecastData, parameterDir, aeroval.observation, aeroval.layer, statisticDir, id, chartOptions);
	} else if (type.startsWith('trgt')) {
		var experimentName = aeroval.experiment.name
		var enableCircle = true
		var enableBars = true
		if (type.startsWith('trgt-an')) {
			experimentName = experimentName.replace('forecast', 'analysis')
		} else if (type.startsWith('trgt-mos')) {
			experimentName = `mos-last-seasons`
			modelDir = 'MOS'
			var enableBars = false
		}
		const mapData = await getMapData(aeroval.project, experimentName, observation, parameterDir, layer, modelDir, parameterDir, aeroval.time, aeroval.season, aeroval.frequency)
		if (!mapData) return
		initTargets(id, enableCircle, enableBars)
		const fairmodeData = await getFairmodeData(aeroval.project, experimentName, region, observation, parameterDir, layer, modelDir, aeroval.time)
		if (!fairmodeData) return
		if (enableCircle) {
			plotTargetCircle(fairmodeData, observation, parameterDir, modelDir, layer, id, chartOptions)
		}
		if (enableBars) {
			plotTargetBars(fairmodeData, observation, parameterDir, modelDir, layer, id, chartOptions)
			fillFairmodeTable(id)
		}
	} else if (type.startsWith('map')) {
		const mapData = await getMapData(aeroval.project, aeroval.experiment.name, observation, parameterDir, layer, modelDir, parameterDir, aeroval.time, aeroval.season, aeroval.frequency)
		if (!mapData) return
		chartOptions.markerRadius = 2
		chartOptions.deltaZoom = -.75
		chartOptions.spacing = [10, 10, 15, 10]
		plotMap(mapData, parameterDir, statisticDir, id, chartOptions)
	} else if (type.startsWith('reg')) {
		chartOptions.height = 280
		chartOptions.countryFlags = false
		const regStatsData = await getRegionalStatisticsData(aeroval.project, aeroval.experiment.name, parameterDir, observation, layer, aeroval.frequency)
		if (regStatsData) plotRegionalStatisticsSingleModel(regStatsData, statisticDir, parameterDir, modelDir, modelVar, false, false, id, chartOptions)
	}
	else if (type.startsWith('qrtrs')) {
		chartOptions.height = 60
		const frequency = 'daily'
		const experimentName = type.startsWith('qrtrs-an') ? aeroval.experiment.name.replace('forecast', 'analysis') : aeroval.experiment.name
		const stripesData = await getStripesData(aeroval.project, experimentName, frequency, region, parameterDir, observation, layer, modelDir, modelVar)
		if (stripesData) plotStripes(stripesData, id, chartOptions)
	} else if (type.startsWith('ctg')) {
		chartOptions.height = 60
		var experimentName = aeroval.experiment.name
		if (type.startsWith('ctg-mos')) {
			experimentName = `mos-last-seasons`
		}

		var i = 0
		var fairmodeData
		for (let modelDir of models) {
			let fairmodeModelData = await getFairmodeData(
				aeroval.project, experimentName, region, observation,
				parameterDir, layer, modelDir, aeroval.time
			)
			if (!fairmodeModelData) break

			if (i === 0) {
				fairmodeData = fairmodeModelData
			} else if (fairmodeData) {
				fairmodeData = mergeFairmodeModelData(fairmodeData, fairmodeModelData)
			}
			i++
		}

		if (!fairmodeData) return
		plotContingencyColumns(fairmodeData, observation, parameterDir, models, layer, id, chartOptions)
	} else {
		console.warn('unknown type chart:', type);
	}
}

function mergeFairmodeModelData(dataLeft: FairmodeData, dataRight: FairmodeData): FairmodeData {
	// Deep clone left to avoid mutating it
	const mergedData: FairmodeData = structuredClone(dataLeft)

	// Iterate over all observation variables
	for (const obsVar of Object.keys(dataRight)) {
		if (!mergedData[obsVar]) mergedData[obsVar] = {}

		for (const obsNetwork of Object.keys(dataRight[obsVar])) {
			if (!mergedData[obsVar][obsNetwork]) mergedData[obsVar][obsNetwork] = {}

			for (const layer of Object.keys(dataRight[obsVar][obsNetwork])) {
				if (!mergedData[obsVar][obsNetwork][layer]) mergedData[obsVar][obsNetwork][layer] = {}

				for (const model of Object.keys(dataRight[obsVar][obsNetwork][layer])) {
					// Assign right model data, overwriting or adding
					mergedData[obsVar][obsNetwork][layer][model] =
						structuredClone(dataRight[obsVar][obsNetwork][layer][model])
				}
			}
		}
	}

	return mergedData
}

async function loadTable(id: string) {
	const region = aeroval.region as string
	if (id == 'table-summary') {
		const frequency = 'daily'
		const forecastHMData = await getHeatmapData(aeroval.project, aeroval.experiment.name, frequency, region, aeroval.time, aeroval.season)
		const analysisHMData = await getHeatmapData(aeroval.project, aeroval.experiment.name.replace('forecast', 'analysis'), frequency, region, aeroval.time, aeroval.season)
		const previousForecastHMData = await getHeatmapData(aeroval.project, aeroval.experiment.name, frequency, region, String(Number(aeroval.time) - 1), aeroval.season)
		const previousAnalysisHMData = await getHeatmapData(aeroval.project, aeroval.experiment.name.replace('forecast', 'analysis'), frequency, region, String(Number(aeroval.time) - 1), aeroval.season)
		if (!forecastHMData || !analysisHMData || !previousForecastHMData || !previousAnalysisHMData) return
		fillSummaryTable(forecastHMData, analysisHMData, previousForecastHMData, previousAnalysisHMData)
	}
}

async function fillSummaryTable(forecastHMData: HMData, analysisHMData: HMData, previousForecastHMData: HMData, previousAnalysisHMData: HMData) {
	const parameters = ['conco3', 'concno2', 'concpm10', 'concpm25', 'concso2', 'concco']
	const observation = 'EEA-UTD'
	const layer = 'Surface'
	const keyTime = `${aeroval.time}-${aeroval.season}`.replace('-All', '-all')
	const prevKeyTime = `${Number(aeroval.time) - 1}-${aeroval.season}`.replace('-All', '-all')
	const region = aeroval.region as string

	const targets = {
		forecast: {
			conco3mda8: 18,
			conco3: 18,
			concno2: 25,
			concpm10: 18,
			concpm25: 18
		},
		analysis: {
			conco3mda8: 16,
			conco3: 16,
			concno2: 22,
			concpm10: 16,
			concpm25: 16
		}
	} as any

	for (let parameter of parameters) {
		const modelVar = aeroval.menu[parameter].obs[observation][layer][aeroval.model.dir].model_var
		const subForecastHMData = forecastHMData[parameter][observation][layer][aeroval.model.dir][modelVar][region]?.[keyTime]
		const subAnalysisHMData = analysisHMData[parameter][observation][layer][aeroval.model.dir][modelVar][region]?.[keyTime]
		const subPreviousForecastHMData = previousForecastHMData[parameter][observation][layer][aeroval.model.dir][modelVar][region]?.[prevKeyTime]
		const subPreviousAnalysisHMData = previousAnalysisHMData[parameter][observation][layer][aeroval.model.dir][modelVar][region]?.[prevKeyTime]

		const analExperimentName = aeroval.experiment.name.replace('forecast', 'analysis')
		const fcstExperimentName = `forecast-anaobs`
		const forecastAnalData = await getForecastData(aeroval.project, analExperimentName, region, observation, parameter, layer)
		const forecastFcstData = await getForecastData(aeroval.project, fcstExperimentName, region, observation, parameter, layer)
		if (!forecastAnalData || !forecastFcstData) break
		const subForecastAnalData = forecastAnalData[parameter][observation][layer][aeroval.model.dir][modelVar][keyTime]
		const subForecastFcstData = forecastFcstData[parameter][observation][layer][aeroval.model.dir][modelVar][keyTime]


		// cellIds
		const td1Element = document.getElementById(`rmse-forecastSuccess-${parameter}`)
		if (td1Element && subForecastHMData) {
			let score = subForecastHMData.rms
			if (score && targets.forecast[parameter]) {
				td1Element.innerHTML = score <= targets.forecast[parameter]
					? `<span style="color: green" title="${score}/${targets.forecast[parameter]}"><i class="bi bi-check-circle-fill"></i></span>`
					: `<span style="color: red" title="${score}/${targets.forecast[parameter]}"><i class="bi bi-x-circle-fill"></i></span>`
			} else {
				td1Element.innerHTML = `-`
			}
		}
		const td2Element = document.getElementById(`rmse-analysisSuccess-${parameter}`)
		if (td2Element && subAnalysisHMData) {
			let score = subAnalysisHMData.rms
			if (score && targets.analysis[parameter]) {
				td2Element.innerHTML = score <= targets.analysis[parameter]
					? `<span style="color: green" title="${score}/${targets.analysis[parameter]}"><i class="bi bi-check-circle-fill"></i></span>`
					: `<span style="color: red" title="${score}/${targets.analysis[parameter]}"><i class="bi bi-x-circle-fill"></i></span>`
			} else {
				td2Element.innerHTML = `-`
			}
		}

		const td3Element = document.getElementById(`rmse-forecastTendency-${parameter}`)
		if (td3Element) {
			if (subForecastHMData && subPreviousForecastHMData) {
				let score = subForecastHMData.rms
				let prevScore = subPreviousForecastHMData.rms
				if (score && prevScore) {
					if (Math.abs(1 - (Number(score) / Number(prevScore))) <= 0.05) {
						td3Element.innerHTML = `<span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 128zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 320z"/></svg></span>`
					} else {
						td3Element.innerHTML = score <= prevScore ? `<span style="color: green"><i class="bi bi-plus-circle-fill"></i></span>` : `<span style="color: red"><i class="bi bi-dash-circle-fill"></i></span>`
					}
				}
			}
			else {
				td3Element.innerHTML = `<span style="color: gray"><i class="bi bi-question-circle-fill"></i></span>`
			}
		}

		const td4Element = document.getElementById(`rmse-analysisTendency-${parameter}`)
		if (td4Element) {
			if (subAnalysisHMData && subPreviousAnalysisHMData) {
				let score = subAnalysisHMData.rms
				let prevScore = subPreviousAnalysisHMData.rms
				if (score && prevScore) {
					td4Element.innerHTML = score <= prevScore ? `<span style="color: green"><i class="bi bi-plus-circle-fill"></i></span>` : `<span style="color: red"><i class="bi bi-dash-circle-fill"></i></span>`
				}
			}
			else {
				td4Element.innerHTML = `<span style="color: gray"><i class="bi bi-question-circle-fill"></i></span>`
			}
		}

		const td5Element = document.getElementById(`assimilation-${parameter}`)
		if (td5Element) {
			let isAssimilated = ((aeroval.model.dir == 'LOTOS' && parameter == 'concso2') || (aeroval.model.dir == 'LOTOS' && parameter == 'concco') || (aeroval.model.dir == 'MOCAGE' && parameter == 'concso2')) ? false : true
			td5Element.innerHTML = isAssimilated == true ? `<span style="color: green"><i class="bi bi-check-circle-fill"></i></span>` : `<span style="color: red"><i class="bi bi-x-circle-fill"></i></span>`
		}

		const td6Element = document.getElementById(`analysisVsForecast-rmse-${parameter}`)
		if (td6Element && subForecastAnalData && subForecastFcstData) {
			let forecastScore = subForecastFcstData.rms.reduce((a, b) => a + b, 0)
			let analysisScore = subForecastAnalData.rms.reduce((a, b) => a + b, 0)
			if (forecastScore && analysisScore) {
				td6Element.innerHTML = analysisScore <= forecastScore ? `<span style="color: green"><i class="bi bi-check-circle-fill"></i></span>` : `<span style="color: red"><i class="bi bi-x-circle-fill"></i></span>`
			}
		}

		const td7Element = document.getElementById(`analysisVsForecast-mnmb-${parameter}`)
		if (td7Element && subForecastFcstData && subForecastAnalData) {
			let forecastScore = subForecastFcstData.mnmb.reduce((a, b) => Math.abs(a) + Math.abs(b), 0)
			let analysisScore = subForecastAnalData.mnmb.reduce((a, b) => Math.abs(a) + Math.abs(b), 0)
			if (forecastScore && analysisScore) {
				td7Element.innerHTML = analysisScore <= forecastScore ? `<span style="color: green"><i class="bi bi-check-circle-fill"></i></span>` : `<span style="color: red"><i class="bi bi-x-circle-fill"></i></span>`
			}
		}

		const td8Element = document.getElementById(`analysisVsForecast-R-${parameter}`)
		if (td8Element && subForecastFcstData && subForecastAnalData) {
			let forecastScore = subForecastFcstData.R.reduce((a, b) => a + b, 0)
			let analysisScore = subForecastAnalData.R.reduce((a, b) => a + b, 0)
			if (forecastScore && analysisScore) {
				td8Element.innerHTML = analysisScore >= forecastScore ? `<span style="color: green"><i class="bi bi-check-circle-fill"></i></span>` : `<span style="color: red"><i class="bi bi-x-circle-fill"></i></span>`
			}
		}
	}
}

function fillFairmodeTable(id: string) {
	const targetDots = document.querySelectorAll(`#${id}-bars .target-dot`)
	let success = 0
	for (let targetDot of targetDots) {
		if (targetDot.innerHTML.includes('fa-circle-check')) {
			success++
		}
	}

	// mqo: get result from circle target
	const circleTargetDot = document.querySelectorAll(`#${id} .target-dot`)[0]
	const MQOSuccess = circleTargetDot.innerHTML.includes('fa-circle-check') ? `<span style="color: green"><i class="bi bi-check-circle-fill"></i></span>` : `<span style="color: red"><i class="bi bi-x-circle-fill"></i></span>`

	// add stats to fairmode table
	const isAnalysis = id.startsWith('trgt-an') ? true : false
	const parameterId = id.split('_')[2]
	const MQOCellId = isAnalysis ? `analysis-mqo-${parameterId}` : `forecast-mqo-${parameterId}`

	// MQO stats
	const MQOCell = document.getElementById(MQOCellId)
	if (MQOCell) {
		MQOCell.innerHTML = MQOSuccess
	}

	// MPI stats
	const MPICellId = isAnalysis ? `analysis-mpi-${parameterId}` : `forecast-mpi-${parameterId}`
	const MPICell = document.getElementById(MPICellId)
	if (MPICell) {
		MPICell.innerHTML = `${success}/${targetDots.length}`
	}

}
/*
function updateTimeSeries() {
	const y1 = (aeroval.time.indexOf('-') != -1) ? aeroval.time.split('-')[0] : aeroval.time
	const y2 = (aeroval.time.indexOf('-') != -1) ? aeroval.time.split('-')[1] : aeroval.time
	const chart = utils.getChartById('ts');
	if (chart) {
		chart.xAxis[0].update({
			min: new Date(parseFloat(y1), 0, 1).valueOf(),
			max: new Date(parseFloat(y2), 11, 31).valueOf(),
		});
		chart.setTitle({ text: `${aeroval.parameter.name} - ${aeroval.region} - ${aeroval.time}` });
	}
}
*/